"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var memo = {};
/**
 * @description 从URL上面获取所有参数。
 * 处理参数前不会进行 URLDecode，但会对 value 自动进行一次 decode。
 * 如果 value 不存在（如 "search?key=" ），会返回 { key: '' }
 *
 * @param {*} [url=location.href] URL
 * @param {string} [delimiter='&'] k1v1与k2v2之间的分隔符，默认 &
 * @param {string} [subDelimiter='='] k与v之间分隔符，默认 =
 * @returns
 */
function getParams(url, delimiter, subDelimiter) {
    if (url === void 0) { url = location.href; }
    if (delimiter === void 0) { delimiter = '&'; }
    if (subDelimiter === void 0) { subDelimiter = '='; }
    var queryString = url.replace(/.+?\?/, '').replace(/#.*/, '');
    var paramArray = queryString.split(delimiter);
    if (!memo[queryString]) {
        memo[queryString] = paramArray.reduce(function (params, kv) {
            var subDelimiterPos = kv.indexOf(subDelimiter);
            if (subDelimiterPos > -1) {
                var key = kv.substr(0, subDelimiterPos);
                if (key) {
                    var value = kv.substr(subDelimiterPos + 1);
                    try {
                        params[key] = decodeURIComponent(value);
                    }
                    catch (_) {
                        // URI malformed.
                        params[key] = value;
                    }
                }
            }
            return params;
        }, {});
    }
    return memo[queryString];
}
exports.default = getParams;
//# sourceMappingURL=get-params.js.map